<template>
    <div class="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div class="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
        <h2 class="text-xl font-bold mb-4 text-gray-800">Delivery Details</h2>
        <p><strong>Date:</strong> {{ formatDate(delivery.createdAt) }}</p>
        <p><strong>Client:</strong> {{ delivery.client.name }}</p>
        <p><strong>Total Amount:</strong> {{ delivery.totalAmount }}</p>
        <p><strong>Status:</strong> {{ delivery.status }}</p>
        <button @click="closeModal" class="mt-4 w-full text-gray-600">Close</button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      delivery: {
      },
    },
    data() {
      return {
      };
    },
    methods: {
      closeModal() {
        this.$emit('closeModal');
      },
      formatDate(date) {
        return new Date(date).toLocaleDateString();
      },
    },
  };
  </script>
  